"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, params) {
  return params[0] + "\u301C" + params[1] + "\u306E\u9577\u3055\u3067\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044";
};